export default "__VITE_ASSET__DyxQPImD__"